import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
<div>
  <strong>#{option.id}</strong> -&nbsp;
  <span className="power-select-customer-name">{option.customer.name}</span> -&nbsp;
  <span>Pickup from <strong>{
    (option.pickup_address && option.pickup_address.house_number_or_name) ? option.pickup_address.house_number_or_name : ''} {
    (option.pickup_address && option.pickup_address.address_line_1) ? option.pickup_address.address_line_1 : ''} {
    (option.pickup_address && option.pickup_address.address_line_2) ? option.pickup_address.address_line_2 : ''} {
    (option.pickup_address && option.pickup_address.address_line_3) ? option.pickup_address.address_line_3 : ''} {
    (option.pickup_address && option.pickup_address.town_city) ? option.pickup_address.town_city : ''} {
    (option.pickup_address && option.pickup_address.postcode) ? option.pickup_address.postcode : ''}
    </strong>
  </span> -  <span>Dropoff to <strong> {
    (option.dropoff_address && option.dropoff_address.house_number_or_name) ? option.dropoff_address.house_number_or_name : ''} {
    (option.dropoff_address && option.dropoff_address.address_line_1) ? option.dropoff_address.address_line_1 : ''} {
    (option.dropoff_address && option.dropoff_address.address_line_2) ? option.dropoff_address.address_line_2 : ''} {
    (option.dropoff_address && option.dropoff_address.address_line_3) ? option.dropoff_address.address_line_3 : ''} {
    (option.dropoff_address && option.dropoff_address.town_city) ? option.dropoff_address.town_city : ''} {
    (option.dropoff_address && option.dropoff_address.postcode) ? option.dropoff_address.postcode : ''}</strong>
  </span> - <span>Vehicle = <strong> ({
    option.vehicle?.type}) {
    option.vehicle?.make} {
    option.vehicle?.model} {
    option.vehicle?.colour} {
    option.vehicle?.registration_number} {
    option.vehicle?.vin_number}</strong>
  </span>
</div>
);

export default class RecentJobsPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      defaultValue: props.defaultValue || '',
      selectedOption: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.getRecentJobs();
  }

  getRecentJobs() {
    var that = this;
    $.ajax({
      url: "/api/v1/portal/jobs/recently-created/for-dropdown-menu",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(jobsJson) {
      that.setState({ jobs: jobsJson});
    });

  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option
    })
    this.props.handleJobSelection(option);
  }

  render() {
    return (
      <PowerSelect
        options={this.state.jobs}
        optionLabelPath="dropdown_box_summary_text"
        selected={this.state.selectedOption}
        selectedOption={this.state.selectedOption}
        onChange={this.handleChange}
        searchEnabled={false}
        placeholder="-- select a Job -- "
        optionComponent={<CustomOptionComponent />}
        required
        />
    )
  }
}
